export const durations = {
  '30s': 30,
  '60s': 60,
  '90s': 90,
  '2min': 120,
  '3min': 180,
  '4min': 240,
  '5min': 300,
  '10min': 600,
};

export const purcentages = {
  '30s': 10,
  '60s': 15,
  '90s': 20,
  '2min': 25,
  '3min': 30,
  '4min': 40,
  '5min': 80,
  '10min': 100,
};

export const times = [
  { time: '30s', rate: '10%', min: 100 },
  { time: '60s', rate: '15%', min: 1000 },
  { time: '90s', rate: '20%', min: 5000 },
  { time: '2min', rate: '25%', min: 10000 },
  { time: '3min', rate: '30%', min: 30000 },
  { time: '4min', rate: '40%', min: 100000 },
  { time: '5min', rate: '80%', min: 200000 },
  { time: '10min', rate: '100%', min: 500000 },
];
